/* unplugin-vue-components disabled */import { render } from "./DeviceAndroid.vue?vue&type=template&id=6b1409fb&scoped=true"
import script from "./DeviceAndroid.vue?vue&type=script&lang=js"
export * from "./DeviceAndroid.vue?vue&type=script&lang=js"

import "./DeviceAndroid.vue?vue&type=style&index=0&id=6b1409fb&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1409fb"]])

export default __exports__